import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
//import {Select, Checkbox, FormControlLabel, MenuItem, InputLabel, FormControl } from '@mui/material';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/base/Portal';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import DateTimePicker from '@mui/lab/DateTimePicker';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import axios from 'axios';
import Autocomplete from '../components/Autocomplete';

import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const userObj = useSelector(state => state.userDetails);
  const [formReset, setFormReset] = React.useState(false);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
    
  const [accountName, setAccountName] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [accountId, setAccountId] = React.useState("");
  const [accountAccountAutocomplete, setAccountAutocomplete] = React.useState({});
  
  const [contactName, setContactName] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [pinCode, setPinCode] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [designation, setDesignation] = React.useState("");

  const [accountList, setAccountList] = React.useState([]);

  // var myCurrentDate=new Date();
	// var myDate=new Date(myCurrentDate);
  // myDate.setDate(myDate.getDate() - 6540);
	// const [dobDate, setDobDate] = React.useState(moment(myDate).format('YYYY-MM-DD'));
  const [dobDate, setDobDate] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setFormReset(!formReset);
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    
    if(props.dataObj && props.dataObj.autoId){
      setContactName(props.dataObj.contactName);
      setMobile(props.dataObj.mobile);
      setEmail(props.dataObj.email);
      setPhone(props.dataObj.phone);
      setAddress(props.dataObj.address);
      setCity(props.dataObj.city);
      setState(props.dataObj.state);
      setPinCode(props.dataObj.zipCode);
      setCountry(props.dataObj.country);
      setDepartment(props.dataObj.department);
      setDesignation(props.dataObj.designation);
      setDobDate(props.dataObj.dateOfBirth);
      setAccountName(props.dataObj.accountName);
      setAccountNumber(props.dataObj.accountNumber);
      setAccountId(props.dataObj.accountId);
    
      setAccountAutocomplete({autoId:props.dataObj.accountId,title:props.dataObj.accountName});

    }else{
      setContactName("");
      setMobile("");
      setEmail("");
      setPhone("");
      setAddress("");
      setCity("");
      setState("");
      setPinCode("");
      setCountry("");
      setDepartment("");
      setDesignation("");
      setDobDate("");
      setAccountName("");
      setAccountNumber("");
      setAccountId("");
      setAccountAutocomplete(null);
      
      if(open && props.accountObj && props.accountObj.autoId && props.accountObj.autoId>0){
        setAccountAutocomplete({autoId:props.accountObj.autoId,title:props.accountObj.accountName});
        setAccountName(props.accountObj.accountName);
        setAccountId(props.accountObj.autoId);
        setAccountNumber(props.accountObj.accountNumber);
      }

    }

    if(open){      
      getApiDataAccounts(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
    }
    

	}, [props.dataObj,open]);
  
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

	function saveData(){
    if(!contactName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter contact name");			
      return false;
    }
    if(!mobile){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter mobile");			
      return false;
    }

    if(email && email.length>0 && !validateEmail(email) ){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }

		if(contactName){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': userObj.registerId,
          'uid': userObj.loginId,
          'fullName': userObj.fullName,
          'token': userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('contactId', props.dataObj.autoId);
        data.append('ownerId', props.dataObj.ownerId);
        data.append('ownerAlias', props.dataObj.ownerAlias);
      }
      data.append('contactName', contactName);
      data.append('mobile', mobile);
      data.append('phone', phone);
      data.append('email', email);
      data.append('address', address);
      data.append('city', city);
      data.append('state', state);
      data.append('zipCode', pinCode);
      data.append('country', country);
      data.append('designation', designation);
      data.append('department', department);
      data.append('accountName', accountName);
      data.append('accountNumber', accountNumber);
      
      if(accountId && accountId>0){
        data.append('accountId', accountId);
      }

      if(dobDate){
        data.append('dateOfBirth', moment(dobDate).format('YYYY-MM-DD'));
      }

      if(props.fullList===true){
        data.append('fullList', 1);
      }else{
        data.append('fullList', 0);
      }

      let apiURL='/crm-create-contacts';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-contacts';
      }
      setSaveLoading(true);       
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);        
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setFormReset(!formReset);
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Contact detail has been saved.");
          props.updatedList(response.data.list);
					return false;

        }else if(response.data.responseTxt==="mobileExists"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Mobile number is already exists with another contact");			
					return false;  

        }else if(response.data.responseTxt==="emailExists"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Email is already exists with another contact");			
					return false;  

        }else if(response.data.responseTxt==="limitexceeded"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your app records limit exceeded. You must upgrade your package to add more data.");			
					return false;  

				}else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Contact detail could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  const setAutoCompleteDataDetail = (obj,accName) => {
    if(obj){
      setAccountId(obj.autoId);
      setAccountName(obj.title);
      setAccountNumber(obj.accountNumber);
    }else if(accName && accName.length>0){
      setAccountName(accName);
      setAccountId(""); 
      setAccountNumber("");    
    }    
  }

  async function getApiDataAccounts(registerId,uid,fullName,token){ 
		let apiUrl=API_URL+'/crm-list-accounts';
		let axiosHeader = {
				  'Content-Type': 'multipart/mixed',
				  'device': 'web',
				  'registerId': registerId,
				  'uid': uid,
				  'fullName': fullName,
				  'token': token,
		  };
		  const config = {
			  method: 'get',
			  url: apiUrl,
			  headers: axiosHeader
		  }
		  await axios(config)
			 .then(response => {
			  if(response && response.data && response.data.responseTxt==="success"){  
				  setAccountList(response.data.list);				 				
			  }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				  navigate('/invalidtoken');
			  }
		  }).catch((error) => {
			    setSeverityAlert("error");
			    setShowAlert(true);
			    setAlertMessage(""+error);			
			    return false;
		  })	
  	}

    function numberOnly(event){
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      } 
    }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} Contact</h4></div>

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Contact Name" onChange={event => setContactName(event.target.value)} value={contactName} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >                          
                              <Autocomplete label="Account Name" toCallParentMethod={setAutoCompleteDataDetail} options={accountList} defaultValue={accountAccountAutocomplete} freeSolo={true} />  
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Mobile" onChange={event => setMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={mobile} fullWidth variant="outlined" inputProps={{maxlength:10}} size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Phone" onChange={event => setPhone(event.target.value)} value={phone} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Email" onChange={event => setEmail(event.target.value)} value={email} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Address" onChange={event => setAddress(event.target.value)} value={address} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="City" onChange={event => setCity(event.target.value)} value={city} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="State" onChange={event => setState(event.target.value)} value={state} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Pin Code" onChange={event => setPinCode(event.target.value)} value={pinCode} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Country" onChange={event => setCountry(event.target.value)} value={country} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Designation" onChange={event => setDesignation(event.target.value)} value={designation} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Department" onChange={event => setDepartment(event.target.value)} value={department} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField 
                                label="Date Of Birth"
                                id="date"                                
                                type="date"
                                size='small'
                                defaultValue={dobDate}
                                fullWidth
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setDobDate(event.target.value)}
                                variant="outlined"
                                />
                          </Grid>

                          


                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Wait</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

    </>
  );

});

export default CustomizedDialogs;